import Cookie from "js-cookie"
import { httpClient } from "./_http"

/**
 * @desc 用户是否为黑名单
 * @param {{ companyId: number }} payload 
 */
export const queryBlackList = (payload = {}) => {
    return httpClient.post("/order/validCustomerIsBlacklist", {
        companyId: Number(Cookie.get("userId")),
        ...payload
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js